export default __webpack_public_path__ + "static/media/Layer 2.0be489e9.svg";